<nav
  style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  "
  class="bg-primary"
>
  <img height="80" src="/assets/logo.svg" class="nav-img" />
  <div
    style="
      display: flex !important;
      align-items: center;
      justify-content: end;
      gap: 10px;
      flex-grow: 1;
    "
  >
    <input
      type="text"
      placeholder="Member ID"
      #memberIdInput
      (keyup.enter)="goToMember(memberIdInput.value)"
      style="height: 34px; border-radius: 4px; color: black"
    />
    <a
      id="headerProfile"
      class="btn btn-default"
      [routerLink]="['/admin/profile']"
      >Profile</a
    >
    <a id="headerLogout" class="btn btn-default" href="#" (click)="logout()"
      >Logout</a
    >
  </div>
</nav>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/header/header.component.html